/** One capacity shared by simulation, setup, rendering and the room protocol. */
export const MAX_PLAYERS = 8;

export const PLAYER_COLOR_NAMES = ['Yellow', 'Blue', 'Red', 'Green', 'Purple', 'Orange', 'Cyan', 'Pink'] as const;
export const PLAYER_COLORS = ['#f5c542', '#3f8cff', '#ef4f3f', '#3fd47a', '#a783ff', '#ff9b45', '#42dce8', '#f58ac8'] as const;
export const PLAYER_COLORS_CB = ['#f0e442', '#0072b2', '#d55e00', '#009e73', '#aa80cc', '#e69f00', '#56b4e9', '#cc79a7'] as const;
